import axios from 'axios';
import { QueryRequest, QueryResponse } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

export const queryCompliance = async (request: QueryRequest): Promise<QueryResponse> => {
    const response = await axios.post(`${API_BASE_URL}/query`, request);
    return response.data;
};
